import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, StyleSheet } from 'react-native'
import { Text } from 'react-native-paper'

interface PropTypes {
  headerMessage?: boolean
}

export const CardExpiredMessage = ({ headerMessage = false }: PropTypes) => {
  const { t } = useTranslation('global')
  return (
    <View style={headerMessage ? styles.viewStyleForHeader : styles.viewStyle}>
      <Text
        style={headerMessage ? styles.textStyleForHeader : styles.textStyle}
      >
        {t('PayNowWithVirtualCard.expired')}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  viewStyle: {
    width: '100%',
    height: 76,
    backgroundColor: 'rgba(246, 174, 45, 0.2)',
    borderRadius: 8,
    paddingVertical: 16,
    paddingHorizontal: 16,
  },
  viewStyleForHeader: {
    height: 76,
    backgroundColor: 'rgba(246, 174, 45, 0.2)',
    paddingVertical: 14,
    paddingHorizontal: 20,
    marginHorizontal: -16,
  },
  textStyle: {
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 22,
    color: '#003353',
  },
  textStyleForHeader: {
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 24,
    color: '#003353',
  },
})
